module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-LightItalic.f703a960.woff2";